import React from 'react'
import { 
    Tooltip,IconButton
    } from '@mui/material';

import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

const CompleteButton = ({...props}) => {

    const { handleComplete, formId, packageId, userId } = props;

    return (
        <Tooltip title="Complete" onClick={e => handleComplete(e, formId, packageId, userId)}>
            <IconButton aria-label="complete" size="large">
                <CheckCircleOutlineIcon />
            </IconButton>
        </Tooltip>
    );
}

export default CompleteButton;